module.exports = "<multiselect-dropdown\n  [settings]=\"emailTypeDDSettings\"\n  [data]=\"ddEmailTypes\"\n  [(ngModel)]=\"selectedDDTypes\"\n  (onSelect)=\"change()\"\n  (onDeSelect)=\"change()\">\n</multiselect-dropdown>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/global/email-type-picker/email-type-picker.component.html
// module id = ./client/app/global/email-type-picker/email-type-picker.component.html
// module chunks = main